import { GroupEvent } from './group-event';
import { DatabaseModel, ModelJson } from './database-model';
import { GroupMember } from './group-member';

export class Group extends DatabaseModel {
    /** Key generated by Firebase */
    public key: string;
    /** 4-digit join ID generated by GroupService */
    public joinId: number;
    /** Timestamp (in ms) of group creation */
    public createdOn: string = '';

    /** Mapped type with `User` keys and `GroupMember` objects */
    public members: { [userKey: string]: GroupMember; } = {};
    /** Mapped type with keys (chronological, generated by .push()) and `GroupEvent` objects */
    public events: { [eventKey: string]: GroupEvent; } = {};

    constructor(key: string = '', json: any = null) {
        super();
        this.key = key ? key : this.genKey();
        if(json) this.fromJson(json);
    }

    public toJson(): ModelJson {
        return {
            key: this.key,
            joinId: this.joinId || null,
            createdOn: this.createdOn,
            members: this.toJsonMap(this.members),
            events: this.toJsonMap(this.events)
        };
    }

    public fromJson(json: any): Group {
        if(json.key) this.key = json.key;
        this.joinId = json.joinId;
        this.createdOn = json.createdOn;
        this.members = this.fromJsonMap<GroupMember>(json.members, GroupMember);
        this.events = this.fromJsonMap<GroupEvent>(json.events, GroupEvent);

        return this;
    }
}
